import { render, staticRenderFns } from "./ownerInvoiceList.vue?vue&type=template&id=5d535e8a&scoped=true"
import script from "./ownerInvoiceList.vue?vue&type=script&lang=js"
export * from "./ownerInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./ownerInvoiceList.vue?vue&type=style&index=0&id=5d535e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d535e8a",
  null
  
)

export default component.exports